import EHRWrapper from './ehr-wrapper';
export default EHRWrapper;